/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as Yup from "yup";
import checkout from "./form";

const {
    formField: {tables},
} = checkout;

const validations = Yup.object().shape({
    [tables.name]: Yup.array().of(
        Yup.object()
            .shape({
                table_id: Yup.number().required(tables.formField.table_id.errorMsg),
                name: Yup.string().required(tables.formField.table_id.errorMsg),
                tips_amount: Yup.number().required(tables.formField.tips_amount.errorMsg),
            })
            .required(tables.errorMsg)
    )
});

export default validations;
